<template>
  <v-card class="edit_firms_tariffs">
    <v-data-table
      :headers="headers"
      :items="filtredFirms"
      :items-per-page="99999999"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Тарифы Организаций</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field
            v-model="search"
            append-icon="search"
            clearable
            label="Поиск ..."
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:item.count="{ item }">
        <span v-if="item.inn === editInn && edit">
          <v-text-field
            label="Количество запросов"
            dense
            v-model="editFirm.count"
          />
        </span>
        <span v-else>
          {{ item.count }}
        </span>
      </template>

      <template v-slot:item.excell="{ item }">
        <div class="flex" v-if="item.excell.length > 0">
          <span
            class="onHover"
            @click="invoce(item.excell[item.excell.length - 1])"
            >Счет</span
          >
          <span>и</span>
          <span
            class="onHover"
            @click="report(item.excell[item.excell.length - 1])"
            >Акт
          </span>
          <span>{{
            `№ ${getLastExcell(item.excell).bill} от ${
              getLastExcell(item.excell).date
            } на ${getLastExcell(item.excell).count_request} запросов, сумма ${
              getLastExcell(item.excell).price
            } ₽ `
          }}</span>
        </div>
        <div class="flex" v-else>Нет счетов и актов</div>
      </template>

      <template v-slot:item.to_date="{ item }">
        <span v-if="item.inn === editInn && edit">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="editFirm.to_date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="editFirm.to_date"
                label="Дата окончания тарифа"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="editFirm.to_date" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false"> Отмена </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(editFirm.to_date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </span>
        <span v-else>
          {{ item.to_date }}
        </span>
      </template>
      <template v-slot:item.tariff="{ item }">
        <span v-if="item.inn === editInn && edit">
          <v-combobox
            :item="item.tariff"
            @change="(e) => setTariff(e, item)"
            :items="tariffList"
            label="Тариф"
            item-text="title"
            dense
        /></span>
        <span v-else>
          {{ tariffList.find((row) => row.id == item.tariff)?.title }}
        </span>
      </template>

      <template v-slot:item.api="{ item }">
        <span v-if="item.inn === editInn && edit">
          <v-checkbox
            v-model="editFirm.api"
            label="API"
            color="info"
            hide-details
          />
        </span>
        <span v-else>
          {{ item.api == 0 ? "Нет" : "Есть" }}
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div v-if="!edit">
          <v-btn small icon @click="editItem(item)">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn small icon @click="billsItem(item)" title="Счета и Акты">
            <v-icon small>mdi-format-list-bulleted-square</v-icon>
          </v-btn>
        </div>

        <div v-else-if="item.inn === editInn">
          <v-btn small icon @click="cancelItem">
            <v-icon small>cancel</v-icon>
          </v-btn>
          <v-btn small icon @click="saveItem(item)">
            <v-icon small>save</v-icon>
          </v-btn>
          <v-btn small icon @click="billsItem(item)" title="Счета и Акты">
            <v-icon small>mdi-format-list-bulleted-square</v-icon>
          </v-btn>
        </div>
        <div v-else>
          <v-btn small icon @click="editItem(item)">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn small icon @click="billsItem(item)" title="Счета и Акты">
            <v-icon small>mdi-format-list-bulleted-square</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <FirmInvoceReport
      v-if="billsObj !== null"
      :show="showBills"
      :item="billsObj"
      @close="showBills = false"
      @invoce="invoce($event)"
      @report="report($event)"
    />
  </v-card>
</template>
<script>
import moment from "moment";
import FirmInvoceReport from "./FirmInvoceAndReport.vue";
import { getReportUrl } from "@/components/api/localglobal.js";
export default {
  name: "edit_firms_tariffs",
  components: {
    FirmInvoceReport,
  },
  data: () => ({
    search: "",
    edit: false,
    editInn: null,
    menu: false,
    showBills: false,
    billsObj: null,
    headers: [
      { text: "ИНН", value: "inn" },
      { text: "Название организации", value: "name" },
      { text: "Последний счет", value: "excell" },
      { text: "Количество запросов", value: "count" },
      { text: "Дата окончания", value: "to_date" },
      { text: "Тариф", value: "tariff" },
      { text: "API", value: "api" },
      { text: "Действия", value: "action" },
    ],
    rules: {
      count: [
        (v) => !!v || "Это поле обязательно для заполнения",
        (v) => (v && v.length >= 9) || "Поле должно не менее 9 символов",
      ],
    },
    editFirm: null,
    dupleEditFirm: null,
  }),
  methods: {
    async getFirmsTariffs() {
      await this.$store.dispatch("GET_PAYMENTS_TARIFFS");
      await this.$store.dispatch("GET_AGENT_FRIMS_TARIFFS");
    },
    editItem(item) {
      this.editInn = item.inn;
      this.editFirm = item;
      this.dupleEditFirm = JSON.parse(JSON.stringify(item));
      this.edit = true;
    },
    billsItem(item) {
      this.billsObj = Object.assign({}, item);
      this.showBills = true;
    },
    async invoce(item) {
      const data = await this.$store.dispatch("getExcellInvoce", item);
      this.fileDownload(`${getReportUrl()}reports/${data.name}`);
    },
    async report(item) {
      const data = await this.$store.dispatch("getExcellReport", item);
      this.fileDownload(`${getReportUrl()}reports/${data.name}`);
    },
    cancelItem() {
      this.edit = false;
      this.editFirm = null;
      this.editInn = null;
    },
    saveItem(item) {
      let { agent_firms_id, count, to_date, api, tariff } = item;
      if (this.dupleEditFirm.tariff !== tariff) {
        const findTarif = this.tariffList.find((row) => row.id === tariff);
        if (findTarif?.valid_period) {
          //меняем кол-во дней в тарифе
          to_date = moment(to_date.replace(/-/gm, "/"))
            .add(findTarif?.valid_period, "days")
            .format("YYYY-MM-DD");
        }
      }
      this.$store.dispatch("SET_AGENT_FIRM_TARIFF", {
        agent_firms_id,
        count,
        to_date,
        api,
        tariff: tariff,
      });
      this.edit = false;
      this.editFirm = null;
      this.editInn = null;
      this.getFirmsTariffs();
    },
    getLastExcell(excell) {
      const last = excell[excell.length - 1];

      const result = {
        bill: last.bill,
        date: moment(last.created_at).format("DD.MM.YYYY"),
        price: last.orderInfo.price,
        count_request: last.orderInfo.count_request,
      };
      return result;
    },
    setTariff(e, item) {
      item.tariff = e.id;
    },
  },
  computed: {
    AgentFirmsTariffs() {
      return this.$store.getters.AgentFirmsTariffs;
    },
    filtredFirms() {
      const reg = new RegExp(this.search, "ig");
      return Array.from(this.AgentFirmsTariffs).filter((item) => {
        return reg.test(item.inn) ||
          reg.test(item.name) ||
          reg.test(item.to_date)
          ? true
          : false;
      });
    },
    tariffList: {
      get() {
        return this.$store.getters.tariffs;
      },
    },
  },
  async created() {
    await this.getFirmsTariffs();
  },
};
</script>
<style lang="sass" scoped>
.flex
  display: flex
  align-items: center
  column-gap: 10px
  span.onHover
    &:hover
      cursor: pointer
      text-decoration: underline
</style>
